module.exports = __webpack_public_path__ + "static/media/loading.fb81e93b.gif";